export default __webpack_public_path__ + "static/media/mhc.0fe7e5ce.png";